<template>
  <div class="situation-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div class="flex-sub margin-right">
          <div class="flex align-center justify-between margin-bottom-xs">
            <div class="flex align-center margin-right-sm basis-smf">
              <span>缴费年度：</span>
              <el-select v-model="year" placeholder="请选择" class="flex-sub">
                <el-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="flex align-center margin-right-sm basis-smf">
              <span>收费项目：</span>
              <el-select v-model="charge" placeholder="请选择" class="flex-sub">
                <el-option
                    v-for="item in chargeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <fiveLevel @upFive="upFive"/>
        </div>
        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{ total }}条数据
        </div>
        <div>
          <el-button
              size="small"
              type="warning"
              @click="exportWuYeQingKuang"
          >导出物业数据
          </el-button>
        </div>
      </div>

      <el-table
          :data="situationList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          border
          style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
        <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
        <el-table-column label="楼门户" >
          <template slot-scope="scope">
            <div>
              {{ scope.row.building_name }}-{{scope.row.element_name}}-{{scope.row.room_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="房屋面积(平米)" prop="mianji"></el-table-column>
        <el-table-column label="房屋性质">
          <template slot-scope="scope">
            <div>
              {{ scope.row.xingzhi | xingzhi }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="户主姓名" prop="huzu_name"></el-table-column>
        <el-table-column label="手机号" prop="huzu_phone"></el-table-column>
        <el-table-column label="居住情况">
          <template slot-scope="scope">
            <div>
              {{ scope.row.juzhu_qingkuang | juzhu_qingkuang }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="应收物业费" prop="yj_wuyefei"></el-table-column>
        <el-table-column label="缴纳物业费" prop="sj_wuyefei"></el-table-column>
        <el-table-column label="缴费状态" prop="username">
          <template slot-scope="scope">
            <div>
              <span style="color: green"    v-if="Number(scope.row.sj_wuyefei)">已缴费</span>
              <span style="color: #d00000"  v-else>未缴费</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                  size="small"
                  type="primary"
                  @click="editItem(scope.row)"
              >编辑
              </el-button>
              <el-button
                  size="small"
                  type="primary"
                  @click="showItem(scope.row)"
              >查看
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="situationList.length > 0"
          class="page-all"
          background
          @current-change="getResidentList"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
    <situationDialog
        :year="year"
        :setId="setId"
        :setItem="setItem"
        :situationDialog="situationDialog"
        @cancelDialog="cancelDialog"
    />
    <situationDetail
        :year="year"
        :setId="setId"
        :setItem="setItem"
        :situationDetail="situationDetail"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>

import situationDialog from "@/views/pages/dialog/situationDialog";
import situationDetail from "@/views/pages/dialog/situationDetail";
import fiveLevel from '@/components/five-level'
import {year, optionList, cost, filesCN, liveSituation, reform, contract, housingNature, zhDate} from "@/utils/utils";
import {wuYeQingKuangList} from "@/api/property";
import {exportWuYeQingKuang} from "@/api/exportExcel";

export default {
  name: "property-situation",
  data() {
    return {
      yearList: optionList(true, year),
      chargeList: optionList(true, cost),
      year: zhDate(new Date(),4),
      charge: 0,
      project: 0,
      community: 0,
      building: 0,
      unit: 0,
      room: 0,
      page: 1,
      limit: 10,
      total: 0,
      situationList: [],
      setId: 0,
      setItem: {},
      situationDialog: false,
      situationDetail: false,
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "物业情况", false);
    this.getResidentList()
  },
  components: {
    fiveLevel,
    situationDialog,
    situationDetail
  },
  methods: {
    // 物业情况导出
    async exportWuYeQingKuang(){
      let _state = await exportWuYeQingKuang(
          this.project,
          this.community,
          this.building,
          this.unit,
          this.room,
          this.year,
          this.charge
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', '物业情况数据.csv');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    //  物业信息编辑后回调
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.situationDialog = false;
        this.situationDetail = false;
        this.getResidentList();
      } else {
        this.setId = 0;
        this.setItem = {};
        this.situationDialog = false;
        this.situationDetail = false;
      }
    },
    //  查看
    showItem(obj){
      this.setItem = obj;
      this.setId = obj.id;
      this.situationDetail = true;
    },
    //  编辑
    editItem(obj){
      this.setItem = obj;
      this.setId = obj.id;
      this.situationDialog = true;
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getResidentList()
    },
    //  获取物业列表
    async getResidentList() {
      let _data = await wuYeQingKuangList(
          this.project,
          this.community,
          this.building,
          this.unit,
          this.room,
          this.year,
          this.charge,
          this.page,
          this.limit
      )
      this.situationList = _data.data
      this.total = _data.total_number
    },
    //  同步更新五级联动
    upFive(val) {
      this.project = val.project
      this.community = val.community
      this.building = val.building
      this.unit = val.unit
      this.room = val.room
    }
  },
  filters: {
    juzhu_qingkuang(val){
      return filesCN(val,liveSituation)
    },
    zonggai(val){
      return filesCN(val,reform)
    },
    wuyehetong(val){
      return filesCN(val,contract)
    },
    xingzhi(val){
      return filesCN(val,housingNature)
    },
  },
  watch: {
    year(){
      this.page = 1
      this.getResidentList()
    }
  },
}
</script>

<style scoped lang="scss">

</style>
